/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CartProductsEditDialog extends Common.GridEditorDialog<CartProductsRow> {
        protected getFormKey() { return CartProductsForm.formKey; }
        protected getLocalTextPrefix() { return CartProductsRow.localTextPrefix; }

        protected form = new CartProductsForm(this.idPrefix);
        public stateIds: number;
        public FranchiseeId: number;
        public OrderStatus: number;
        constructor() {
            super();           
            
        }

       
        
       
       

      

    }
}